import { SCREENS } from "utils/constants";
import Create from "./Create";
import Delete from "./Delete";
import Detail from "./Detail";
import Edit from "./Edit";
import List from "./List";

const routes = [
  {
    path: SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.LIST.path,
    exact: true,
    element: <List />,
  },
  {
    path: SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.CREATE.path,
    element: <Create />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.EDIT.path}/:id`,
    element: <Edit />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.DETAIL.path}/:id`,
    element: <Detail />,
  },
  {
    path: `${SCREENS.PRIVATE.ADMIN.DYNAMIC_DOCUMENTS.DELETE.path}/:id`,
    element: <Delete />,
  },
];

export default routes;
